import auth from './Auth';
import authIdPositiva from './AuthIdPositiva';
import configuration from '../envConfig';

export const getHeader = (options?: any) => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    CnasVersao: configuration.versao,
    Authorization: `Bearer ${auth.getToken()}`,
    ...options
  };
};

export const getHeaderRotasAbertas = (options?: any) => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    CnasVersao: configuration.versao,
    ...options
  };
};

export const getHeaderUrlEncoded = (options?: any) => {
  return {
    Accept: 'text/pdf,application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    CnasVersao: configuration.versao,
    Authorization: `Bearer ${auth.getToken()}`,
    ...options
  };
};

export const getHeaderIdPositiva = (options?: any) => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    CnasVersao: configuration.versao,
    ...options,
  };
};

export const getHeaderIdPositivaUrlEncoded = (options?: any) => {
  return {
    Accept: 'text/pdf,application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    CnasVersao: configuration.versao,
    ...options,
  };
};
